import apiKeysActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  query: createAsyncRequestReducer(apiKeysActionTypes.FETCH_API_KEYS_LIST),
  delete: createAsyncRequestReducer(apiKeysActionTypes.DELETE_API_KEY),
  create: createAsyncRequestReducer(apiKeysActionTypes.CREATE_API_KEY),
};

export default combineReducers(reducers);
